import {
	SET_CONTRACT_MODE, SET_MAX_RECURRING
} from '../actionTypes/index';

const initialState = {
	contractMode: "new-contract",
	maxRecurring: 99999999999
};

export default (state = initialState, { type, payload }) => {
	switch (type) {
		case SET_CONTRACT_MODE:
			return {
				...state,
				contractMode: payload
			};
		case SET_MAX_RECURRING:
			return {
				...state,
				maxRecurring: payload
			};
		default:
			return state;
	}
};
